/*
 *
 *. Btn__Primary.jsx
 *
 */
//------------------------------------------------------------------------------
// External dep.
//------------------------------------------------------------------------------
import React from "react";
import LoadingIndicator from "react-loading-indicator";
const classNames = require("classnames");
//------------------------------------------------------------------------------
// Class
//------------------------------------------------------------------------------
export default class BtnPrimary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };
  }

  renderLoadingIndicator() {
    if (this.props.isLoading) {
      return (
        <div>
          <div>
            <LoadingIndicator
              color={{
                red: 255,
                green: 255,
                blue: 255,
                alpha: 1
              }}
            />
          </div>
        </div>
      );
    }
    return this.props.children;
  }

  render() {
    const style = classNames({
      cta: true,
      "cta-comp": true,
      "cta--loading": this.state.isLoading,
      "cta--disabled": this.props.disabled,
      "cta--inline": this.props.isInline,
      "cta--special": this.props.isHighlight
    });
    return (
      <button
        className={style}
        style={this.props.style}
        onClick={this.props.onClick}
        disabled={this.props.disabled}
      >
        {this.renderLoadingIndicator()}
      </button>
    );
  }
}
